export default class ContractRangeRoleParameter {
  role: any;

  seniorities: any[] = [];

  constructor(obj: any = {}) {
    this.role = obj.role;
    this.seniorities = obj.seniorities || [];
  }

  public static of(obj: any = {}): ContractRangeRoleParameter {
    return new ContractRangeRoleParameter(obj || {});
  }

  public static ofList(obj: any[]): ContractRangeRoleParameter[] {
    return obj.map(this.of);
  }
}
